import { render, staticRenderFns } from "./worksetupmanage.vue?vue&type=template&id=30734907&scoped=true&"
import script from "./worksetupmanage.vue?vue&type=script&lang=js&"
export * from "./worksetupmanage.vue?vue&type=script&lang=js&"
import style0 from "./worksetupmanage.vue?vue&type=style&index=0&id=30734907&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30734907",
  null
  
)

export default component.exports